import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iDateBoxDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DateBox/DateBox';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';

export const donePopupValidationGroup = 'donePopupOrderEditValidationGroup';

export const donePopupCloseImmediatelyButtonId = 'donePopupCloseImmediatelyButton';
const donePopupCloseImmediatelyButtonOptions: iButtonDisplayOptions = {
    id: donePopupCloseImmediatelyButtonId,
    //
    type: 'success',
    width: '200px',
    validationGroup: donePopupValidationGroup,
    //
    text: 't~OrderEditScreenDonePopup:closeImmediatelyButton',
};
propsStore.insert(donePopupCloseImmediatelyButtonOptions);

export const donePopupCloseDraftButtonId = 'donePopupCloseDraftButton';
const donePopupCloseDraftButtonOptions: iButtonDisplayOptions = {
    id: donePopupCloseDraftButtonId,
    //
    type: 'success',
    width: '200px',
    //
    text: 't~OrderEditScreenDonePopup:closeDraftButton',
};
propsStore.insert(donePopupCloseDraftButtonOptions);

export const donePopupCloseDraftDateBoxId = 'donePopupCloseDraftDateBox';
const donePopupCloseDraftDateBoxOptions: iDateBoxDisplayOptions = {
    id: donePopupCloseDraftDateBoxId,
    //
    type: 'datetime',
    width: '300px',
};
propsStore.insert(donePopupCloseDraftDateBoxOptions);
